import React from "react";

interface GoogleFullTextIconProps {
  width: string;
  height: string;
}

const GoogleFullTextIcon: React.FC<GoogleFullTextIconProps> = ({
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      fontSize={20}
      viewBox="0 0 482 159"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M206.301 83.6578C206.301 106.445 188.46 123.236 166.565 123.236C144.671 123.236 126.83 106.445 126.83 83.6578C126.83 60.71 144.671 44.0791 166.565 44.0791C188.46 44.0791 206.301 60.71 206.301 83.6578ZM188.907 83.6578C188.907 69.418 178.566 59.675 166.565 59.675C154.565 59.675 144.224 69.418 144.224 83.6578C144.224 97.7548 154.565 107.641 166.565 107.641C178.566 107.641 188.907 97.7369 188.907 83.6578Z"
        fill="#EA4335"
      />
      <path
        d="M292.022 83.6578C292.022 106.445 274.181 123.236 252.287 123.236C230.392 123.236 212.551 106.445 212.551 83.6578C212.551 60.7278 230.392 44.0791 252.287 44.0791C274.181 44.0791 292.022 60.71 292.022 83.6578ZM274.628 83.6578C274.628 69.418 264.288 59.675 252.287 59.675C240.286 59.675 229.946 69.418 229.946 83.6578C229.946 97.7548 240.286 107.641 252.287 107.641C264.288 107.641 274.628 97.7369 274.628 83.6578Z"
        fill="#FBBC05"
      />
      <path
        d="M374.171 46.4702V117.526C374.171 146.755 356.92 158.693 336.525 158.693C317.328 158.693 305.773 145.863 301.416 135.371L316.56 129.072C319.256 135.513 325.864 143.115 336.508 143.115C349.562 143.115 357.652 135.067 357.652 119.917V114.225H357.045C353.152 119.025 345.651 123.219 336.186 123.219C316.381 123.219 298.237 105.981 298.237 83.8005C298.237 61.4595 316.381 44.0791 336.186 44.0791C345.633 44.0791 353.134 48.2725 357.045 52.9299H357.652V46.4881H374.171V46.4702ZM358.884 83.8005C358.884 69.8641 349.58 59.675 337.74 59.675C325.739 59.675 315.685 69.8641 315.685 83.8005C315.685 97.5942 325.739 107.641 337.74 107.641C349.58 107.641 358.884 97.5942 358.884 83.8005Z"
        fill="#4285F4"
      />
      <path
        d="M401.406 4.82153V120.81H384.44V4.82153H401.406Z"
        fill="#34A853"
      />
      <path
        d="M467.518 96.684L481.019 105.678C476.662 112.119 466.161 123.218 448.017 123.218C425.515 123.218 408.71 105.838 408.71 83.6398C408.71 60.1032 425.658 44.0612 446.07 44.0612C466.625 44.0612 476.68 60.4065 479.966 69.2395L481.769 73.7362L428.819 95.649C432.872 103.59 439.177 107.64 448.017 107.64C456.874 107.64 463.018 103.286 467.518 96.684ZM425.961 82.4443L461.357 67.7584C459.41 62.8155 453.553 59.3716 446.659 59.3716C437.819 59.3716 425.515 67.1695 425.961 82.4443Z"
        fill="#EA4335"
      />
      <path
        d="M62.6108 73.3616V56.5701H119.24C119.794 59.4966 120.08 62.9584 120.08 66.7057C120.08 79.3037 116.633 94.8818 105.525 105.981C94.7205 117.223 80.9158 123.219 62.6286 123.219C28.733 123.219 0.230774 95.6313 0.230774 61.7628C0.230774 27.8943 28.733 0.307007 62.6286 0.307007C81.3801 0.307007 94.7383 7.65886 104.775 17.2413L92.9168 29.0899C85.7198 22.3447 75.969 17.0985 62.6108 17.0985C37.8588 17.0985 18.5001 37.0306 18.5001 61.7628C18.5001 86.495 37.8588 106.427 62.6108 106.427C78.6656 106.427 87.8092 99.9853 93.6668 94.1324C98.4172 89.3858 101.542 82.6049 102.775 73.3438L62.6108 73.3616Z"
        fill="#4285F4"
      />
    </svg>
  );
};

export default GoogleFullTextIcon;
